import { PageDefaultSegmentWithHeader } from "@sis/react-library"
import { ScheduleDerivsActionsLeft } from "./ScheduleDerivsActionsLeft"
import { useEffect } from "react"
import { useMatch, useSearchParams } from "react-router-dom";
import { scheduleRoutesCombined } from "../ScheduleNavigation";
import { derivState } from "../../../redux/deriv/derivSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { Alert, Box, useTheme } from "@mui/material";
import { loadEventDerivs } from "../../../redux/deriv/derivActions";
import { ScheduleCommonDetails } from "../scheduleCommon/ScheduleCommonDetails";
import { rdsState } from "../../../redux/rds/rdsSlice";
import { LoadingBackground } from "../../shared/LoadingBackground";
import { LoadingError } from "../../shared/LoadingError";
import { ScheduleDerivsList } from "./ScheduleDerivsList";
import { ScheduleDerivsActionsRight } from "./ScheduleDerivsActionsRight";
import { Deriv } from "../../../interfaces/dtos/deriv";
import { rdsMeeting_Dto } from "../../../interfaces/dtos/rdsMeeting";
import { getSearchCategory, getSearchDate, updateSearchParamsForCategory, updateSearchParamsForDate } from "../schedulePage/schedulePageHelper";
import { getDateKey } from "../../../redux/common/commonActions";
import { RppTitle } from "../../shared/RppTitle";
import { getEventDescForTitle, segmentHeaderDefault } from "../../../utils/commonUtils";

export const ScheduleDerivsPage = () => {

    const match = useMatch(scheduleRoutesCombined.derivs_eventMatch);
    const eventIdAsString = match?.params.eventId ?? "0";
    const eventId = Number.parseInt(eventIdAsString);
    const deriv = useAppSelector(derivState);
    const rds = useAppSelector(rdsState);
    const dispatch = useAppDispatch();
    const theme = useTheme();

    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        dispatch(loadEventDerivs(eventId))
        // we only want the conditions below
        // eslint-disable-next-line
    }, [match])

    const getDescForSorting = (deriv: Deriv) => {
        // When sorting alphabetically, replace the actual numbered words with numbers so they are ordered by number
        return deriv.marketName?.toLowerCase()
            .replace("one", "1").replace("two", "2").replace("three", "3").replace("four", "4").replace("five", "5")
            .replace("six", "6").replace("seven", "7").replace("eight", "8").replace("nine", "9") ?? '';
    }

    const event = rds.rdsEvents.find((e) => e.id === eventId);
    const eventDerivs = deriv.eventDerivs.filter((e) => e.eventId === eventId)
        .toSorted((a, b) => ((a.timestamp! > b.timestamp! ? -1 : 1)))
        .toSorted((a, b) => ((getDescForSorting(a) > getDescForSorting(b) ? 1 : -1)));
    const meeting = rds.rdsMeetings.find((m) => m.id === event?.meetingId);

    const checkSearchParams = (meeting: rdsMeeting_Dto) => {
        const searchDate = getSearchDate(searchParams);
        const searchCategory = getSearchCategory(searchParams);
        if (!searchDate || getDateKey(searchDate) !== getDateKey(meeting.startDate)) {
            setSearchParams(updateSearchParamsForDate(searchParams, meeting.startDate));
        }
        if (!searchCategory || searchCategory !== meeting.categoryCode) {
            setSearchParams(updateSearchParamsForCategory(searchParams, meeting.categoryCode));
        }
    }

    useEffect(() => {
        if (event) {
            const meeting = rds.rdsMeetings.find((m) => m.id === event.meetingId);
            if (meeting) { checkSearchParams(meeting); }
        }
        // we only want the conditions below
        // eslint-disable-next-line
    }, [rds])

    return (
        <PageDefaultSegmentWithHeader
            id='schedule-derivs'
            width='100%'
            headingElement={<ScheduleDerivsActionsLeft eventId={eventId} />}
            headingBackground={segmentHeaderDefault(theme)}
            headingColor={theme.palette.common.white}
            headingRightElement={<ScheduleDerivsActionsRight eventId={eventId} />}
        >
            <RppTitle title={`Derivs:  ${getEventDescForTitle(meeting, event)}`} />
            {deriv.loading &&
                <Box sx={{ height: '150px' }}><LoadingBackground /></Box>
            }
            {!deriv.loading && !event &&
                <LoadingError sx={{ marginTop: '10px' }}> Event not found {eventId}</LoadingError>
            }
            {!deriv.loading && event &&
                <>
                    <ScheduleCommonDetails
                        event={event}
                        bettingPhase=""
                        suspended={false}
                        meeting={meeting}
                    />
                    {eventDerivs.length > 0 &&
                        <ScheduleDerivsList eventDerivs={eventDerivs} />
                    }
                    {eventDerivs.length === 0 &&
                        <Alert severity='warning'>No derivatives found</Alert>
                    }

                </>
            }
        </PageDefaultSegmentWithHeader>
    )
}
